export function timeFix() {
  const time = new Date()
  const hour = time.getHours()
  return hour < 9 ? '早上好' : hour <= 11 ? '上午好' : hour <= 13 ? '中午好' : hour < 20 ? '下午好' : '晚上好'
}

export function welcome() {
  const arr = ['休息一会儿吧', '准备吃什么呢?', '要不要打一把 DOTA', '我猜你可能累了']
  const index = Math.floor(Math.random() * arr.length)
  return arr[index]
}

/**
 * 触发 window.resize
 */
export function triggerWindowResizeEvent() {
  const event = document.createEvent('HTMLEvents')
  event.initEvent('resize', true, true)
  event.eventType = 'message'
  window.dispatchEvent(event)
}

export function handleScrollHeader(callback) {
  let timer = 0

  let beforeScrollTop = window.pageYOffset
  callback = callback || function () {}
  window.addEventListener(
    'scroll',
    event => {
      clearTimeout(timer)
      timer = setTimeout(() => {
        let direction = 'up'
        const afterScrollTop = window.pageYOffset
        const delta = afterScrollTop - beforeScrollTop
        if (delta === 0) {
          return false
        }
        direction = delta > 0 ? 'down' : 'up'
        callback(direction)
        beforeScrollTop = afterScrollTop
      }, 50)
    },
    false
  )
}

export function isIE() {
  const bw = window.navigator.userAgent
  const compare = (s) => bw.indexOf(s) >= 0
  const ie11 = (() => 'ActiveXObject' in window)()
  return compare('MSIE') || ie11
}

/**
 * Remove loading animate
 * @param id parent element id or class
 * @param timeout
 */
export function removeLoadingAnimate(id = '', timeout = 1500) {
  if (id === '') {
    return
  }
  setTimeout(() => {
    document.body.removeChild(document.getElementById(id))
  }, timeout)
}


export function tsFormat(unixTime, type = "Y-M-D H:i:s") {
  var date = new Date(unixTime * 1000); //时间戳为10位需*1000，时间戳为13位的话不需乘1000
  var datetime = "";
  datetime += date.getFullYear() + type.substring(1, 2);
  datetime += (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + type.substring(3, 4);
  datetime += (date.getDate() < 10 ? '0' + (date.getDate()) : date.getDate());
  if (type.substring(5, 6)) {
    if (type.substring(5, 6).charCodeAt() > 255) {
      datetime += type.substring(5, 6);
      if (type.substring(7, 8)) {
        datetime += " " + (date.getHours() < 10 ? '0' + (date.getHours()) : date.getHours());
        if (type.substring(9, 10)) {
          datetime += type.substring(8, 9) + (date.getMinutes() < 10 ? '0' + (date.getMinutes()) : date.getMinutes());
          if (type.substring(11, 12)) {
            datetime += type.substring(10, 11) + (date.getSeconds() < 10 ? '0' + (date.getSeconds()) : date.getSeconds());
          };
        };
      };
    } else {
      datetime += " " + (date.getHours() < 10 ? '0' + (date.getHours()) : date.getHours());
      if (type.substring(8, 9)) {
        datetime += type.substring(7, 8) + (date.getMinutes() < 10 ? '0' + (date.getMinutes()) : date.getMinutes());
        if (type.substring(10, 11)) {
          datetime += type.substring(9, 10) + (date.getSeconds() < 10 ? '0' + (date.getSeconds()) : date.getSeconds());
        };
      };
    };
  };
  return datetime;
}

// 将秒数转换为时分秒 xxx => hh:mm:ss
export function formatSeconds(value) {
  const hour = Math.floor(value / 3600)
  const minute = Math.floor((value % 3600) / 60)
  // 秒不可以是小数
  const second = Math.floor(value % 60)
  return `${hour.toString().padStart(2, '0')}:${minute.toString().padStart(2, '0')}:${second.toString().padStart(2, '0')}`
}

/**
 * 将对象中的 null 值替换为空对象 {}
 *
 * @param obj 需要替换的对象
 * @returns 替换后的新对象
 */
export const replaceNullWithEmptyObject = obj => {
  const newObj = Array.isArray(obj) ? [] : {}
  for (const key in obj) {
    if (obj[key] === null) {
      newObj[key] = Array.isArray(obj) ? [] : {}
    } else if (typeof obj[key] === 'object' && obj[key] !== null) {
      newObj[key] = replaceNullWithEmptyObject(obj[key])
    } else {
      newObj[key] = obj[key]
    }
  }
  return newObj
}

/**
 * 判断对象中的所有值是否都是空字符串、undefined或null
 *
 * @param obj 要检查的对象
 * @returns 如果对象中的所有值都是空字符串、undefined或null，则返回true；否则返回false
 */
export function areAllValuesEmptyOrUndefinedOrNull(obj) {
  for (const key in obj) {
      if (obj.hasOwnProperty(key)) {
          const value = obj[key]
          if (value !== '' && value !== undefined && value !== null) {
              return false
          }
      }
  }
  return true
}